import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { RoleList } from '@/components/pages/Role/List';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { pages } from '@/settings/pages';

export const RoleListPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const title = t('pages.role.list.title');
  const { enabled, loading } = useFeatureFlag('product_admin_roles');

  useEffect(() => {
    if (!loading && !enabled) {
      navigate(pages.top);
    }
  }, [enabled, loading, navigate]);

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      hasHeaderDivider={true}
      breadcrumbItems={[{ label: title }]}
      containerType="wide"
    >
      <RoleList />
    </PageRootWrapper>
  );
};
